export default {
    // When the bound element is inserted into the DOM...
    inserted(el, { value, arg }, vnode) {
        const event = new Event('input', { bubbles: true });
        if (value === undefined) {
            return;
        }

        el.value = value;

        if (arg) {
            vnode.context.$refs[arg].text = value;
        }

        el.dispatchEvent(event);
    }
};
